export enum PreviousDaysEnum {
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_WEEK = 'LAST_WEEK',
  LAST_2_WEEKS = 'LAST_2_WEEKS',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
}
